import Button from '@/components/atom/Button';
import LucideIcon from '@/components/atom/Icons/LucideIcon';
import BottomFixedContainer from '@/components/molecule/BottomFixedContainer';
import MainContentTitle from '@/components/molecule/MainContentTitle';
import SectionCard from '@/components/molecule/SectionCard';
import PATH from '@/src/routes/path';
import { useNavigate } from 'react-router-dom';
import Typo from '@/components/atom/Typo';
import Table from '@/components/atom/Table';
import { useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import useAgGridHeaderRefresh from '@/hooks/useAgGridHeaderRefresh';
import { detailListColumn } from './column';
import DetailSection from '@/components/organism/DetailSection';
import { DetailSctionRenderer } from '@/components/organism/DetailSection/renderer';
import { formatter } from '@/src/utils/formatter';
import { BUTTON_CONST } from '@/src/constants/buttons';

const BACK_PATH = PATH.FILTER_TEST;
const EDIT_PATH = PATH.FORM_TEST;

const testMockData = {
  id: 386,
  aId: 'eddy',
  storeOwnerId: 410,
  createdAt: '2024-01-08T03:19:19.256Z',
  phone: '010****3097',
  isDeletedStoreOwner: false,
  businessName: '주식회사 쓱싹',
  category: '카페',
  ownerName: '김**',
  businessRegisterNumber: '8528602742',
  openDate: '2021-12-22T03:18:47.403Z',
  storeName: '에디 테스트',
  status: 'APPROVED',
  requestCode: 'SIGN_UP_REQUEST',
  address: '서울 마포구 성지3길 74',
  businessRegisterMedia: {
    id: 5588,
    service: 'PLUSPOT_STORE',
    authorId: null,
    type: 'big-image',
    format: 'png',
    fileName: '2024_1_8f795i6g2e3c4.png',
    originName: 'images.png',
    folder: 'staging/',
    bufferFullUrl:
      'https://d3ur2z0045hhbx.cloudfront.net/staging/2024_1_8f795i6g2e3c4.png',
    smallFullUrl:
      'https://d3ur2z0045hhbx.cloudfront.net/staging/s_2024_1_8f795i6g2e3c4.png',
    mediumFullUrl:
      'https://d3ur2z0045hhbx.cloudfront.net/staging/m_2024_1_8f795i6g2e3c4.png',
    largeFullUrl:
      'https://d3ur2z0045hhbx.cloudfront.net/staging/l_2024_1_8f795i6g2e3c4.png',
  },
  salesPermitMedia: null,
  rejectCode: null,
  rejectReason: null,
  store: {
    id: 516,
    createdAt: '2024-01-08T03:19:49.844Z',
    updatedAt: '2024-01-09T03:47:08.145Z',
    deletedAt: null,
    storeType: 'Normal',
    storeRegisterType: 'StoreOwner',
    viewable: true,
    operationalStatus: 'Normal',
    approvalStatus: 'Approved',
    creditAmount: null,
    checkInExpireDay: null,
    name: '에디 테스트',
    mainPhoneNumber: '02-123-1234',
    regionDepth1: '서울',
    regionDepth2: '마포구',
    regionDepth3: '합정동',
    street: '서울 마포구 성지3길 74',
    zibun: '서울 마포구 합정동 359-2',
    detail: null,
    priceRange: null,
    homepageUrl: null,
    introduction: null,
    inActivatedAt: null,
    notice: null,
    businessDayString: null,
    dayOffString: null,
    lat: 37.5459946744478,
    lng: 126.916917715256,
    geoCredit: {
      type: 'Credit',
      coordinates: [126.916917715, 37.545994674],
    },
    category: '카페',
    businessRegisterNumber: '852-86-02742',
    businessName: '주식회사 쓱싹',
    openDate: '2021-12-22T03:18:47.403Z',
    radiusMeter: 3000,
    ownerName: '김승범',
    storeNotices: null,
    storeMenus: [],
    thumbnailMedia: {
      id: 5592,
      service: 'PLUSPOT_STORE',
      authorId: null,
      type: 'big-image',
      format: 'png',
      fileName: '2024_1_9g57a5e3i9562.png',
      originName: 'images.png',
      folder: 'staging//',
      bufferFullUrl:
        'https://d3ur2z0045hhbx.cloudfront.net/staging//2024_1_9g57a5e3i9562.png',
      smallFullUrl:
        'https://d3ur2z0045hhbx.cloudfront.net/staging//s_2024_1_9g57a5e3i9562.png',
      mediumFullUrl:
        'https://d3ur2z0045hhbx.cloudfront.net/staging//m_2024_1_9g57a5e3i9562.png',
      largeFullUrl:
        'https://d3ur2z0045hhbx.cloudfront.net/staging//l_2024_1_9g57a5e3i9562.png',
    },
    storeMedias: [],
    businessRegisterMedia: {
      id: 5588,
      service: 'PLUSPOT_STORE',
      authorId: null,
      type: 'big-image',
      format: 'png',
      fileName: '2024_1_8f795i6g2e3c4.png',
      originName: 'images.png',
      folder: 'staging/',
      bufferFullUrl:
        'https://d3ur2z0045hhbx.cloudfront.net/staging/2024_1_8f795i6g2e3c4.png',
      smallFullUrl:
        'https://d3ur2z0045hhbx.cloudfront.net/staging/s_2024_1_8f795i6g2e3c4.png',
      mediumFullUrl:
        'https://d3ur2z0045hhbx.cloudfront.net/staging/m_2024_1_8f795i6g2e3c4.png',
      largeFullUrl:
        'https://d3ur2z0045hhbx.cloudfront.net/staging/l_2024_1_8f795i6g2e3c4.png',
    },
    salesPermitMedia: null,
  },
  latestRequest: null,
  storeOwner: {
    id: 410,
    createdAt: '2024-01-08T03:19:19.256Z',
    updatedAt: '2024-01-08T03:19:49.844Z',
    deletedAt: null,
    aId: 'eddy',
    email: 'ksb3097@slogup.com',
    name: 'tqUAnnWuvBmRgpfM7na3vQ==',
    phone: '3Juu5F6vNGbI89RRBnxFxw==',
    gender: 'N/A',
    storeOwnerStatus: 'APPROVED',
    withdrawalReason: null,
    account: {
      id: 1288,
      createdAt: '2024-01-08T03:19:19.256Z',
      updatedAt: '2024-01-17T03:00:10.089Z',
      deletedAt: null,
      changedTempPassword: false,
      loginFailCount: 0,
      loggedInAt: '2024-01-17T02:37:32.266Z',
      passChangedAt: '2024-01-09T05:43:15.517Z',
      passHeldOffAt: '2024-04-08T05:43:15.517Z',
      agreedAt: '2024-01-16T02:58:15.439Z',
      certifiedAt: null,
      lockedAt: null,
      unUsedLockedAt: null,
      lastActivatedAt: '2024-01-17T03:00:07.497Z',
      activated: true,
      pushReceivable: null,
      marketingPushReceivable: true,
      disturbForbiddenHHMMStartAt: null,
      disturbForbiddenHHMMEndAt: null,
      emailReceivable: true,
      messageReceivable: true,
      kakaoReceivable: true,
      optionalTermsReadAt: '2024-01-16T02:58:15.389Z',
      termsCheckedAt: '2024-01-16T02:58:18.591Z',
      storePushReceivable: true,
    },
  },
};

const noticeList: any[] = [
  {
    id: 1,
    titleKr: '제목',
    titleEn: '',
    createdAt: '2021-09-09',
    updatedAt: '2021-09-09',
    isViewable: true,
  },
  {
    id: 2,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 3,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 4,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 5,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 6,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 2,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 2,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 2,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 7,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 8,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 9,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
  {
    id: 10,
    titleKr: '제목2',
    titleEn: 'Title2',
    createdAt: '2021-10-09',
    updatedAt: '2023-09-09',
    isViewable: false,
  },
];

const formatToBizNum = (value: string) => {
  if (!value) return '-';
  value = value?.replace(/[^0-9]/g, '');
  let tempNum = '';

  if (value.length < 4) {
    return value;
  } else if (value?.length < 6) {
    tempNum += value.substring(0, 3);
    tempNum += '-';
    tempNum += value.substring(3);

    return tempNum;
  } else if (value?.length < 11) {
    tempNum += value.substring(0, 3);
    tempNum += '-';
    tempNum += value.substring(3, 5);
    tempNum += '-';
    tempNum += value.substring(5);

    return tempNum;
  } else {
    tempNum += value.substring(0, 3);
    tempNum += '-';
    tempNum += value.substring(3, 5);
    tempNum += '-';
    tempNum += value.substring(5);

    return tempNum;
  }
};

export default function DetailTestPage() {
  // util
  const gridRef = useRef<AgGridReact>(null);
  const navigate = useNavigate();

  // data
  const columnDefs: ColDef[] = detailListColumn();

  // state
  const [isReady, setIsReady] = useState<boolean>(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // event
  const handlePaginationChange = ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }) => {
    setPage(page);
    setPageSize(pageSize);
  };

  // render
  const renderBottomFixedContent = () => {
    return (
      <BottomFixedContainer>
        <div className="flex justify-between">
          <Button
            className="w-max"
            buttonSize="medium"
            buttonColor="outline"
            onClick={() => navigate(BACK_PATH)}
          >
            <div className="flex items-center gap-x-2">
              <LucideIcon name="ChevronLeft" size={16} />
              {BUTTON_CONST.backToList}
            </div>
          </Button>
          <Button
            className="w-40"
            buttonSize="medium"
            buttonColor="outline"
            onClick={() => navigate(EDIT_PATH)}
          >
            <div className="flex items-center gap-x-2">{BUTTON_CONST.edit}</div>
          </Button>
        </div>
      </BottomFixedContainer>
    );
  };

  // effect
  useAgGridHeaderRefresh({
    gridRef: gridRef.current,
    isReady,
    headerSet: [],
  });

  return (
    <article className="pb-fixedFooterUsedPadding">
      <MainContentTitle
        breadcrumbList={['test1', 'test2']}
        pageTitle="testDetail"
      />
      <div className="flex flex-col gap-4">
        <DetailSection
          sectionTitle="section12"
          data={testMockData}
          contents={[
            [
              {
                key: 'createdAt',
                lable: '신청 일시',
                render: DetailSctionRenderer.DATE(),
              },
              {
                key: 'businessName',
                lable: '상호명(법인명)',
                render: DetailSctionRenderer.BOLD_TEXT(),
              },
              {
                key: 'category',
                lable: '업종',
              },
              {
                key: 'openDate',
                lable: '개업일',
                render: DetailSctionRenderer.DATE(),
              },
              {
                key: 'aId',
                lable: '아이디',
              },
              {
                key: ['store', 'mainPhoneNumber'],
                lable: '대표 번호',
              },
              {
                key: ['storeOwner', 'account', 'marketingPushReceivable'],
                lable: '마케팅 광고 동의',
                render: DetailSctionRenderer.Y_OR_N(),
              },
              {
                key: ['businessRegisterMedia', 'bufferFullUrl'],
                lable: '사업자등록증',
                render: DetailSctionRenderer.IMAGE(),
              },
            ],
            [
              {
                key: 'storeName',
                lable: '매장명',
              },
              {
                key: 'ownerName',
                lable: '대표자명',
              },
              {
                key: 'businessRegisterNumber',
                lable: '사업자등록번호',
                render: DetailSctionRenderer.FORMATTER({
                  formatter: formatToBizNum,
                }),
              },
              {
                key: 'createdAt',
                lable: '매장 주소',
                valueSetter: data => {
                  return (
                    (data?.store?.street || data?.store?.zibun || '-') +
                    ' ' +
                    (data?.store?.detail || '')
                  );
                },
              },
              {
                key: ['storeOwner', 'email'],
                lable: '대표 이메일',
              },
              {
                key: 'phone',
                lable: '핸드폰 번호',
                render: DetailSctionRenderer.FORMATTER({
                  formatter: formatter.PHONE,
                }),
              },
              {
                key: 'status',
                lable: '신청 상태',
                render: DetailSctionRenderer.BADGE({
                  options: [
                    {
                      key: 'APPROVED',
                      label: '승인 완료',
                      badgeColor: 'green',
                      textBadgeColor: 'gray',
                    },
                    { key: 'APPROVED', label: '승인 완료' },
                  ],
                }),
              },
              {
                key: ['store', 'salesPermitMedia', 'bufferFullUrl'],
                lable: '영업 허가증',
                render: DetailSctionRenderer.IMAGE(),
              },
            ],
          ]}
        />
        <DetailSection
          sectionTitle="section12"
          data={testMockData}
          contents={[
            [
              {
                key: 'createdAt',
                lable: '신청 일시',
                render: DetailSctionRenderer.DATE(),
              },
              {
                key: 'businessName',
                lable: '상호명(법인명)',
                render: DetailSctionRenderer.BOLD_TEXT(),
              },
              {
                key: 'category',
                lable: '업종',
              },
              {
                key: 'openDate',
                lable: '개업일',
                render: DetailSctionRenderer.DATE(),
              },
              {
                key: 'aId',
                lable: '아이디',
              },
              {
                key: ['store', 'mainPhoneNumber'],
                lable: '대표 번호',
              },
              {
                key: ['storeOwner', 'account', 'marketingPushReceivable'],
                lable: '마케팅 광고 동의',
                render: DetailSctionRenderer.Y_OR_N(),
              },
              {
                key: ['businessRegisterMedia', 'bufferFullUrl'],
                lable: '사업자등록증',
                render: DetailSctionRenderer.IMAGE(),
              },
            ],
            [
              {
                key: 'storeName',
                lable: '매장명',
              },
              {
                key: 'ownerName',
                lable: '대표자명',
              },
              {
                key: 'businessRegisterNumber',
                lable: '사업자등록번호',
                render: DetailSctionRenderer.FORMATTER({
                  formatter: formatToBizNum,
                }),
              },
              {
                key: 'createdAt',
                lable: '매장 주소',
                valueSetter: data => {
                  return (
                    (data?.store?.street || data?.store?.zibun || '-') +
                    ' ' +
                    (data?.store?.detail || '')
                  );
                },
              },
              {
                key: ['storeOwner', 'email'],
                lable: '대표 이메일',
              },
              {
                key: 'phone',
                lable: '핸드폰 번호',
                render: DetailSctionRenderer.FORMATTER({
                  formatter: formatter.PHONE,
                }),
              },
              {
                key: 'status',
                lable: '신청 상태',
                render: DetailSctionRenderer.BADGE({
                  options: [
                    {
                      key: 'APPROVED',
                      label: '승인 완료',
                      badgeColor: 'green',
                      textBadgeColor: 'gray',
                    },
                    { key: 'APPROVED', label: '승인 완료' },
                  ],
                }),
              },
              {
                key: ['store', 'thumbnailMedia', 'bufferFullUrl'],
                lable: '영업 허가증',
                render: DetailSctionRenderer.IMAGE(),
              },
            ],
          ]}
        />
        <SectionCard cardTitle="변동 내역">
          <div className="mb-2">
            <Typo typoType="b18sb">총 이용 기간</Typo>{' '}
            <Typo typoType="b18r">2022-05-01 ~ 2023-06-23 (1년 7개월)</Typo>
          </div>
          <div className="w-full">
            <Table
              ref={gridRef}
              rowData={noticeList}
              isPaginationDataMapping
              columnDefs={columnDefs}
              onGridReady={() => setIsReady(true)}
              total={100}
              page={page}
              pageSize={pageSize}
              handlePaginationClick={(page, pageSize) =>
                handlePaginationChange({ page, pageSize })
              }
            />
          </div>
        </SectionCard>
      </div>
      {renderBottomFixedContent()}
    </article>
  );
}
